import { render, staticRenderFns } from "./page30.vue?vue&type=template&id=52835252&scoped=true&"
import script from "./page30.vue?vue&type=script&lang=js&"
export * from "./page30.vue?vue&type=script&lang=js&"
import style0 from "./page30.vue?vue&type=style&index=0&id=52835252&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52835252",
  null
  
)

export default component.exports